import SetsExercise from './sets-exercise'

export default class CountableSetsExercise extends SetsExercise {}
